import React, { useState, useEffect } from 'react';
import './Header.css';
import logo1 from './images/logo1.png';
import logo2 from './images/logo2.png';

function Header() {

  return (
    <div className="Header">
      <div className="gridHead">
        <div>
          <img
              src={logo1}
              alt="Logo 1"
            />
        </div>

        <div>
          <img
              src={logo2}
              alt="Logo 2"
            />
        </div>
      </div>
    </div>
  );
}

export default Header;
